import { useEffect, useState } from "react";

// Phones get MobileApp. Tablets get journal+habits with a left drawer.
// Cover iPad Pro 13" landscape (~1376px) via touch, without treating
// mouse-driven laptops at similar widths as tablets.
export const MOBILE_SHELL_QUERY = "(max-width: 767px)";
export const TABLET_SHELL_QUERY = [
  "(min-width: 768px) and (max-width: 1180px)",
  "(min-width: 768px) and (max-width: 1440px) and (any-pointer: coarse)",
].join(", ");

const getMatch = (query) =>
  typeof window !== "undefined" && window.matchMedia
    ? window.matchMedia(query).matches
    : false;

function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => getMatch(query));
  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, [query]);
  return matches;
}

export function useIsTablet() {
  return useMediaQuery(TABLET_SHELL_QUERY);
}

export default function useIsMobile() {
  return useMediaQuery(MOBILE_SHELL_QUERY);
}
